import { type UtmTags } from './aliases';
import {
  type EventTypes,
  type ReferralEventType,
  type routePaths,
} from './constants';

export type ActivityTrackerClientArgs = {
  userId?: number | Array<number | undefined>;
};

export type ReferralEventArgs = {
  event: ReferralEventType;
  userId?: number;
  url?: string;
  urlParameters?: Record<string, string>;
  referer?: string;
  productSlug?: string;
  fbpCookie?: string;
  ttpCookie?: string;
  scidCookie?: string;
  campaignUtmTags?: UtmTags;
};

export enum QueuedEventType {
  Event = 'event',
  Referral = 'referral',
}

// `type` is optional on the event variant for backwards-compatibility with
// existing queued entries; absence means QueuedEventType.Event.
export type ActivityTrackerQueuedEvent = {
  type?: QueuedEventType.Event;
  event: EventTypes;
  transitionFrom: string;
  params?: Record<string, unknown>;
  baseEventOverrides?: Record<string, unknown>;
};

export type ActivityTrackerQueuedReferral = {
  type: QueuedEventType.Referral;
  args: ReferralEventArgs;
};

export type ActivityTrackerQueuedObject =
  ActivityTrackerQueuedEvent | ActivityTrackerQueuedReferral;

export type RouteGroupType = (typeof routePaths)[keyof typeof routePaths];
